import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A cluster of gem crystals. Two colour variants, and a looping "pulse" that
// breathes the cluster's SCALE up and down about its base — the example for the
// scale animation channel. The shards are named "shards" so the pulse drives
// them while the rocky base stays put.
function cluster(gem: string, glow: string): () => Part[] {
  const shard = (h: number, r: number, pos: [number, number, number], tilt: [number, number, number], color: string): Part =>
    ({ geometry: new THREE.ConeGeometry(r, h, 5), color, position: pos, rotation: tilt, name: "shards" });
  return () => [
    { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#5f6268", position: [0, 0.08, 0], scale: [1.3, 0.6, 1.3] },
    shard(0.46, 0.08, [0, 0.32, 0], [0, 0, 0], gem),
    shard(0.3, 0.06, [-0.12, 0.22, 0.05], [0, 0, 0.4], glow),
    shard(0.34, 0.06, [0.13, 0.24, -0.04], [0.1, 0, -0.5], glow),
    shard(0.22, 0.05, [0.05, 0.18, 0.13], [0.5, 0, 0.1], gem),
  ];
}

export const crystal = defineModel({
  id: "crystal",
  batchId: "standard",
  name: "Crystal cluster",
  tags: ["prop", "resource", "gem", "animated", "fantasy"],
  summary: "A faceted gem cluster that pulses with light; amethyst or emerald.",
  author: "age-of-mcp",
  footprint: 0.3,
  variants: [
    { id: "amethyst", label: "Amethyst", parts: cluster("#9a5fd0", "#c89bf0") },
    { id: "emerald", label: "Emerald", parts: cluster("#2f9e6a", "#6fd6a3") },
  ],
  animations: [
    {
      id: "pulse",
      label: "Pulse",
      duration: 2.2,
      loop: true,
      tracks: [
        {
          target: "shards",
          pivot: [0, 0.1, 0],
          scale: [
            { t: 0, value: 1 },
            { t: 1.1, value: [1.06, 1.12, 1.06], ease: "sine" },
            { t: 2.2, value: 1, ease: "sine" },
          ],
        },
      ],
    },
  ],
});
